var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Select from '../components/Select';
import Field from './Field';
var RFFSelect = function (_a) {
    var defaultValue = _a.defaultValue, name = _a.name, other = __rest(_a, ["defaultValue", "name"]);
    return (React.createElement(Field, { defaultValue: defaultValue, name: name }, function (_a) {
        var input = _a.input, meta = _a.meta, props = __rest(_a, ["input", "meta"]);
        return (React.createElement(Select, __assign({}, input, props, other, { error: meta.error && meta.touched, value: input.value, onChange: input.onChange, onBlur: input.onBlur, helperText: meta.touched && meta.error })));
    }));
};
RFFSelect.defaultProps = {
    defaultValue: null,
    disabled: false,
    error: false,
    helperText: '',
    variant: 'outlined',
};
export default RFFSelect;
//# sourceMappingURL=Select.js.map